import { Component, EventEmitter, Output, Input, ChangeDetectorRef, NgZone } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { SelectionModel } from '@angular/cdk/collections';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { DriverNameComponent } from '@shared/components/driver-name/driver-name.component';
import { EHailingDriverComponent } from '@shared/components/e-hailing-driver/e-hailing-driver.component';
import { SatMotorState } from "@store/sat-motor/sat-motor.state";
import { Select, Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { CALCULATE_PREMIUM, CALCULATE_PREMIUM_PAYLOAD, ENDT_SAVE_EXTRA_COVERLIST_DATA, STORE_COVERAGE_TYPE, STORE_COVERAGE_VEHICLE_DETAILS, STORE_EHAILING_DETAILS, STORE_EXTRA_COVER_PACKAGE, STORE_ORI_PREVIOUS_EXTRA_COVER_ENDT, STORE_PREVIOUS_EXTRA_COVER_ENDT, STORE_THAILAND_DATE, UPDATE_ENDORSEMENT_STEP2 } from '@store/sat-motor/sat-motor.action';
import { UserResponse } from '@interfaces/user';
import { FormatDecimalCoveragePipe } from '@shared/pipes/format-decimal-coverage/format-decimal.pipe';
import { RemoveCommaPipe } from '@shared/pipes/remove-comma/remove-comma.pipe';
import { ScrollToError } from '@shared/classes/scroll-to-error';
import { SimpleModalComponent } from '@shared/components/modal/simple-modal/simple-modal.component';
import { MyDateAdapter } from "@shared/helpers/date.adapter";
import { NxDateAdapter, NX_DATE_FORMATS, NxDatefieldModule } from '@aposin/ng-aquila/datefield';
import moment from "moment";
import { formatDate } from '@angular/common';
import { DatePipe } from '@angular/common';
import { NxMomentDateModule } from '@aposin/ng-aquila/moment-date-adapter';
import { WarningPopupComponent } from '@shared/components/modal/warning-popup/warning-popup.component';
import { ExtraCoveragePopupEndtComponent } from '@shared/components/modal/extra-coverage-popup-endt/extra-coverage-popup-endt.component';


export const MY_FORMATS = {
  parse: {
    dateInput: "DD/MM/YYYY",
  },
  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: 'app-extra-coverage-endorsement',
  standalone: true,
  imports: [
    NxMomentDateModule,
    SharedModule,
    DriverNameComponent,
    EHailingDriverComponent,
    NxDatefieldModule
  ],
  providers: [
    { provide: NxDateAdapter, useClass: MyDateAdapter },
    { provide: NX_DATE_FORMATS, useValue: MY_FORMATS }
  ],
  templateUrl: './extra-coverage-endorsement.component.html',
  styleUrl: './extra-coverage-endorsement.component.scss',
})
export class ExtraCoverageEndorsementComponent {
  coverageFmGroup!: FormGroup;
  @Input() isComprehensive = false;
  @Input() isThirdParty = false;
  @Input() isThirdPartyFireTheft = false;
  @Input() defaultDriver: any;
  @Output() isSelected = new EventEmitter();
  @Output() selectedItem = new EventEmitter();
  templateDialogRef?: NxModalRef<any>;
  extraCoverDetailForm: FormGroup;
  warningPopupModal?: NxModalRef<WarningPopupComponent>;
  @Select(SatMotorState.coveragePremium) coveragePremium$: Observable<SatMotorState>;
  @Select(SatMotorState.endtCoveragePremium) endtCoveragePremium$: Observable<SatMotorState>;
  @Output() endtCalculatePremium = new EventEmitter<unknown>();

  constructor(private readonly dialogService: NxDialogService,
    private fb: FormBuilder,
    private store: Store,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone) {
    this.decimalFmt = new FormatDecimalCoveragePipe();
    this.numberFmt = new RemoveCommaPipe();
    this.extraCoverDetailForm = this.fb.group({
      checkedAll: [false],
      extraCoverPackage: [""],
      extraCoverPackageSummary: [""],
      driverNameDetails: new FormGroup({}),
      ehailingDriverDetails: new FormGroup({}),
      subCoverSumInsured: [""], // for sub sumInsured
      //subCoverSumInsured:["", [Validators.required]],
      dropdownSubCover: [""],// for sub dropdown
      extraCoverPackageDto: [""]
    });

  }
  componentDialogRef?: NxModalRef<ExtraCoveragePopupEndtComponent>;
  selection: any;
  allComplete: boolean = true;
  subCovList: any;
  subCovPackageList: any;
  extraCoverDetails: any;
  packageDescription: any;
  userInfo: any;
  extraCoverList: any = [];
  reinstateExtraCoverList: any = [];
  checkPrivateHireCar = [];
  checkThailandTrip = [];
  privateHireCarIsSelected: boolean = false;
  thailandTripIsSelected: boolean = false;
  rahmahExtraCoverList = [];
  topExtraCoverList = [];
  defaultedExtraCoverList = [];
  allSelectedWithRahmahExtraCoverList = [];
  selectExtraCoverAppDrive = [];
  unnamedOrNamedDriverObj = [];
  initSelectedExtraCoverageList = [];
  subCoverList = [];
  disabledPreviousExtraCoverList = [];
  oriPreviousExtraCoverList = [];
  cngeRiskDrvrDtoForPopupList = [];
  coverDto: any;
  updateSelectedAndAllListToOPUS: any;
  subExtraCoverDropdownList: any;
  numberFmt: any;
  decimalFmt: any;
  isWaiver: boolean = false;
  coverCode: any;
  isAllDriver: boolean = false;
  subCovPackageDesc: any;
  costInd: boolean = false;
  countCallSubCovPackageList = 0;
  countInitExtraCoverageList: any;
  passNextBtn: any;
  countInitSelectedExtraCoverageList = 0;
  p2pCodeList = []; //for design purpose
  selectedCheckboxP2p = [];
  vendorCodeList = [];
  disableAddMore: boolean = false;
  disableTopCheckbox: boolean = false;
  cnoteType: any;
  endtPreviousVehicleData: any;
  issuanceData: any;
  thailandDates: any;
  showThailandTripPopup: boolean = false;
  previousSubCoverCodes: any;
  noOfDayLabel = "NO. OF DAY : ";
  amountPerDayLabel = "AMOUNT PER DAY (RM) : ";
  planUnitLabel = "PLAN / UNIT : ";
  amountPerDayFormName = "_AMOUNT_PER_DAY";
  noOfDayFormName = "_NO_OF_DAY";
  mtRoadPlacementTblInd: boolean = false;
  mtRoadEligibleInd: boolean = false;
  endtHtgePol: any;
  perilWarningPopup: boolean = false;

  ngOnInit() {
    this.endtPreviousVehicleData = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step1?.endtPreviousVehicleData ?? null);
    this.userInfo = this.store.selectSnapshot<UserResponse>((state) => state.UserState.user);
    this.countInitExtraCoverageList = this.store.selectSnapshot<UserResponse>((state) => state.SatMotorState.data?.step3?.coverage?.countSelectedExtraCover);
    this.passNextBtn = this.store.selectSnapshot<UserResponse>((state) => state.SatMotorState.data?.step3?.coverage?.passNextBtn);
    this.issuanceData = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement.step1.issuance);
    this.thailandDates = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement?.step3?.coverage?.extracover?.thailandDate);
    this.disabledPreviousExtraCoverList = this.store.selectSnapshot<any>(state => state.SatMotorState?.previousExtraCover);
    this.oriPreviousExtraCoverList = this.store.selectSnapshot<any>(state => state.SatMotorState?.oriPreviousExtraCover);
    this.endtHtgePol = this.store.selectSnapshot<any>(state => state.SatMotorState?.endtHtgePol ?? state.SatMotorState?.endorsement?.step1?.endtPreviousVehicleData ??  null);

    this.selection = new SelectionModel<any>(true, []);
    this.extraCoverList.forEach(element => {
      this.selection.select(element)
    });
    //this.populateExtraCoverage();

    this.extraCoverList = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement?.step3?.coverage?.extracover?.extraCoverPackage);
    this.extraCoverDetailForm.patchValue({
      dropdownSubCover: this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement?.step3?.coverage?.extracover?.dropdownSubCover)
    });

    this.isAllDriver = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement?.step3?.coverage?.extracover?.driverNameDetails.vehicleAlldrvrInd);
    this.isWaiver = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement?.step3?.coverage?.extracover?.driverNameDetails.vehicleUnNamedDrvrInd);
    this.setExtraCoverageForm();
  }

  ngAfterViewInit() {

    this.endtCoveragePremium$.subscribe((state) => {
      let stCngeNote: any, stRiskList: any, stCoverList: any, stCoverDto: any;
      if (state) {
        if ((stCngeNote = state["data"]["cngeNoteDto"]) && (stRiskList = stCngeNote["riskList"]) && stRiskList.length > 0) {
          this.cnoteType = stCngeNote?.cnoteType;
          this.mtRoadPlacementTblInd = stCngeNote?.mtRoadPlacementTblInd;
          this.mtRoadEligibleInd = stCngeNote?.mtRoadEligibleInd;
          this.cngeRiskDrvrDtoForPopupList = stRiskList?.[0]?.cngeRiskDrvrDtoList;

          if ((stCoverList = stRiskList[0]["coverList"]) && stCoverList.length > 0) {
            this.subCovPackageDesc = stCoverList[0].subCovPackageDesc;
            this.costInd = stCoverList[0].costInd;
            this.subCoverList = stCoverList[0].subCoverList; //p2p save to db
            this.isAllDriver = stCoverList[0].vehicleAlldrvrInd;
            this.isWaiver = stCoverList[0].vehicleUnNamedDrvrInd;
            this.coverCode = stCoverList[0].coverCode;

            if ((stCoverList[0]["coverDto"])) {
              stCoverDto = stCoverList[0]["coverDto"];
              this.coverDto = stCoverList[0]["coverDto"]; //third party missing premium
              if (stCoverDto && stCoverDto["subCovList"]) {
                this.subCovList = stCoverDto["subCovList"];
                this.subCovList = this.subCovList.map((obj) => {
                  return {
                    ...obj,
                    subcoverNarrCode: obj.templateCode,
                    subcoverNarrDesc: obj.sumInsuredDisplay,
                  };
                });
                this.updateSelectedAndAllListToOPUS = this.subCovList;
              }
              if (stCoverDto && stCoverDto["subCovPackageList"]) {
                this.subCovPackageList = stCoverDto["subCovPackageList"][0];
              }

              if (this.subCovPackageList?.packageCode) {
                this.rahmahExtraCoverList = this.subCovList.filter(o1 => o1.top == true && o1.subCovPackage === this.subCovPackageList.packageCode &&
                  o1.enabled == false && o1.subCoverPrem == 0);
              } else {
                this.rahmahExtraCoverList = [];
              }
            }
          }
        }
      }

      if (this.subCovList) {
        this.extraCoverageDisplaySetup();
        this.previousExtraCoverListToDisable();
        this.extraCoverToDisplayInSummary();
        this.privateHireCar();
        this.thailandTripExtraCoverage();
        this.setExtraCoverageForm();
        this.setReinstateExtraCoverageForm();
        this.verifyChanges();
        this.setCR14PackageAfterSaveAsDraft();
        this.remainingSeeMoreList();
        this.checkIsDisabledCheckbox("");
        //this.namedOrUnnamedValidation();
        //this.disableInitExtraCoverage();
      }
    });

  } 

  namedOrUnnamedValidation(){
    //for all driver checkbox
    this.unnamedOrNamedDriverObj = this.disabledPreviousExtraCoverList?.filter(o1 => (o1.subCoverCode === "A200" || o1.subCoverCode === "07"));
    if(this.unnamedOrNamedDriverObj && this.unnamedOrNamedDriverObj?.length > 0){
      this.extraCoverList = this.extraCoverList.map( obj1 => {
        if(obj1.subCoverCode === this.unnamedOrNamedDriverObj[0].subCoverCode){
          return { ...obj1, enabled: false}
        }
        return obj1;
      });
    }
  }

  extraCoverageDisplaySetup() {
    const packageCode = this.subCovPackageList?.packageCode;
    const validPackageCode = packageCode !== undefined ? packageCode : null;
    const previousSubCoverList = this.endtHtgePol?.riskList?.[0]?.coverList?.[0]?.subCoverList?.filter(o1 => o1.subCoverPrem > 0) || [];
    this.previousSubCoverCodes = new Set(previousSubCoverList.map(o => o.subCoverCode)) || [];

    this.topExtraCoverList = this.subCovList.filter(o1 =>
      o1.top === true && o1.selected === true
      // cater specific for motor RW & motor ERW
      && ((o1.subCoverCode === "PAB-RW" && o1.planCode != null && o1.planCode !== '' && this.mtRoadPlacementTblInd == false) || (o1.subCoverCode === "PAB-ERW" && o1.planCode !== '') || o1.enabled === false)
      && o1.subCoverPrem == 0
      && (validPackageCode === null || o1.subCovPackage !== validPackageCode)
      && !this.previousSubCoverCodes.has(o1.subCoverCode)
    );

    this.defaultedExtraCoverList = this.subCovList.filter(o1 => o1.top === true && o1.selected === false && (validPackageCode === null || o1.subCovPackage !== validPackageCode));
    this.extraCoverList = this.subCovList.filter(o1 => o1.selected === true && (validPackageCode === null || o1.subCovPackage !== validPackageCode));
    //filter topExtraCoverList from this.extraCoverList
    this.extraCoverList = this.extraCoverList.filter(o1 => !this.topExtraCoverList.some(o2 => o2.subCoverCode === o1.subCoverCode));


    this.allSelectedWithRahmahExtraCoverList = this.rahmahExtraCoverList.concat(this.topExtraCoverList.concat(this.extraCoverList));
    this.extraCoverDetailForm.controls['extraCoverPackage'].setValue(this.allSelectedWithRahmahExtraCoverList); //to save quotation
    this.extraCoverDetailForm.controls['extraCoverPackageDto'].setValue(this.updateSelectedAndAllListToOPUS);//send to ODM
  }

  extraCoverToDisplayInSummary() {
    let toDisplayInSummary = {
      subCovPackageList: this.subCovPackageList,
      subCovPackageDesc: this.subCovPackageDesc,
      costInd: this.costInd,
      rahmahPackageList: this.rahmahExtraCoverList,
      topExtraCoverList: this.topExtraCoverList,
      selectedExtraCoverList: this.extraCoverList
    }
    this.extraCoverDetailForm.controls['extraCoverPackageSummary'].setValue(toDisplayInSummary);
  }

  previousExtraCoverListToDisable() {
    //disabled previous extra cover list
    if (this.cnoteType === 'ENDT17') {
      if (!this.disabledPreviousExtraCoverList) {
        this.oriPreviousExtraCoverList = this.rahmahExtraCoverList.concat(this.topExtraCoverList.concat(this.extraCoverList));
        this.store.dispatch(new STORE_ORI_PREVIOUS_EXTRA_COVER_ENDT(this.oriPreviousExtraCoverList));
        this.disabledPreviousExtraCoverList = this.extraCoverList.map((obj) => {
          if (this.previousSubCoverCodes.has(obj.subCoverCode)) {
            return { ...obj, enabled: false };
          }
          return obj;
        });

        this.store.dispatch(new STORE_PREVIOUS_EXTRA_COVER_ENDT(this.disabledPreviousExtraCoverList));
      }

      this.extraCoverList = this.extraCoverList.filter(o1 => !this.disabledPreviousExtraCoverList.some(o2 => o2.subCoverCode === o1.subCoverCode));
    }
  }

  verifyChanges() {
    if (!this.countInitExtraCoverageList && (!this.costInd || this.extraCoverageWithoutSelectPackageChanges() ||
       (this.costInd && !this.subCovPackageList)
    )) {
      this.countInitExtraCoverageList = 1;
      let payload = {
        subCovList: this.subCovList,
        countInitExtraCoverageList: this.countInitExtraCoverageList
      }
      this.store.dispatch(new ENDT_SAVE_EXTRA_COVERLIST_DATA(payload));
    } else if (!this.extraCoverageWithoutSelectPackageChanges() && this.costInd && this.subCovPackageList && this.countCallSubCovPackageList === 1 && !this.passNextBtn) {
      let payload = {
        subCovList: this.subCovList,
        passNextBtn: true
      }

      this.store.dispatch(new ENDT_SAVE_EXTRA_COVERLIST_DATA(payload));
    }
  }

  extraCoverageWithoutSelectPackageChanges(): boolean{
    if(this.costInd && this.subCovPackageList && !this.subCovPackageList?.selected){
      return true;
    }else{
      return false;
    }
  }

  remainingSeeMoreList() {
    const packageCode = this.subCovPackageList?.packageCode
    let originalExtraCoverList = this.subCovList.filter(o1 => !this.allSelectedWithRahmahExtraCoverList.some(o2 => o1.subCoverCode === o2.subCoverCode) &&
      (packageCode === undefined || packageCode === '' || o1.subCovPackage !== packageCode) && o1.top == false
    );

    if (originalExtraCoverList && originalExtraCoverList?.length == 0) {
      this.disableAddMore = true;
    } else {
      this.disableAddMore = false;
    }
  }

  setCR14PackageAfterSaveAsDraft() {
    if (this.costInd) {
      //removed enabled == true for Active quotation
      let cr14List = this.subCovList.filter(o1 => o1.top == true && o1.selected == true && o1.subCovPackage === this.subCovPackageList?.packageCode);
      this.countCallSubCovPackageList++;
      if (cr14List && cr14List.length > 0 && this.countCallSubCovPackageList == 1) {
        this.emitData(true, this.subCovPackageList?.packageCode, "defaultedCR14Value");
      }
    }
  }

  setExtraCoverageForm() {
    if (this.cnoteType === 'ENDT17') {
      this.extraCoverList?.forEach((obj, idx) => {
        obj.mtExtCovDtoList?.forEach((subItem, subIdx) => {
          if (subItem.type === 'INPUT') {
            if (!subItem.disable) {
              this.extraCoverDetailForm.addControl(
                obj.subCoverCode,
                new FormControl('', [
                  Validators.required,
                  Validators.min(0.01),
                  Validators.pattern(/^(?!0(?:\.0{1,2})?$)(\d{1,8}(,\d{3})*)(\.\d{1,2})?$/)
                ])
              );
              if (obj.subCoverSumInsured > 0) {
                this.extraCoverDetailForm.patchValue({
                  [obj.subCoverCode]: this.decimalFmt.transform(obj.subCoverSumInsured)
                });
              }
            } else {
              if (!this.extraCoverDetailForm.contains(obj.subCoverCode) && obj.subCoverSumInsured > 0) {
                this.extraCoverDetailForm.addControl(obj.subCoverCode, new FormControl(this.decimalFmt.transform(obj.subCoverSumInsured)));
                this.extraCoverDetailForm.get(obj.subCoverCode)?.disable();
              }
            }

          } else if (subItem.type === 'DROPDOWN' || subItem.type === 'CHECKBOX_P2P') {

            if (obj.subCoverCode === '112' && subItem.label === this.noOfDayLabel) {
              let noOfDayFormName = obj.subCoverCode + this.noOfDayFormName;
              this.extraCoverDetailForm.addControl(noOfDayFormName, new FormControl('', Validators.required));
              if (obj.subCoverNumberOfDays > 0 || obj.subCoverDays > 0) {
                const noOfDays = obj.subCoverNumberOfDays > 0 ? obj.subCoverNumberOfDays : obj.subCoverDays;

                this.extraCoverDetailForm.patchValue({
                  [noOfDayFormName]: this.getSubCoverNumberOfDaysAsString(noOfDays)
                });
              }

            } else if (obj.subCoverCode === '112' && subItem.label === this.amountPerDayLabel) {
              let amountPerDayFormName = obj.subCoverCode + this.amountPerDayFormName;
              this.extraCoverDetailForm.addControl(amountPerDayFormName, new FormControl('', Validators.required));
              if (obj.subCoverAmtday > 0) {
                this.extraCoverDetailForm.patchValue({
                  [amountPerDayFormName]: obj.subCoverAmtday
                });
              }

            } else if (subItem.type === 'CHECKBOX_P2P') {
              let multiCheckboxFormName = "CHECKBOX_P2P";
              this.extraCoverDetailForm.addControl(multiCheckboxFormName, new FormControl('', Validators.required));
              if (obj.vendorList) {
                this.p2pCodeList = obj.vendorList.split(",");
                this.extraCoverDetailForm.patchValue({
                  CHECKBOX_P2P: obj.vendorList.split(",")
                });
              } else {
                this.p2pCodeList = []; //design purpose
              }
            } else {
              this.extraCoverDetailForm.addControl(obj.subCoverCode, new FormControl('', Validators.required));
              if (obj.planCode) {
                this.extraCoverDetailForm.patchValue({
                  [obj.subCoverCode]: obj.planCode
                });
              }
            }
          }
        });
      });
    }
  }

  setReinstateExtraCoverageForm() {
    if (this.cnoteType === 'ENDT29') {
      this.extraCoverList?.forEach((obj, idx) => {
        obj.mtExtCovDtoList?.forEach((subItem, subIdx) => {
          if (subItem.type === 'INPUT' && obj.claimInd) {
            if (obj.reinstateInd) {
              if (this.extraCoverDetailForm.contains(obj.subCoverCode)) {
                this.extraCoverDetailForm.removeControl(obj.subCoverCode);
              }

              this.extraCoverDetailForm.addControl(
                obj.subCoverCode,
                new FormControl('', [
                  Validators.required,
                  Validators.min(0.01),
                  Validators.pattern(/^(?!0(?:\.0{1,2})?$)(\d{1,8}(,\d{3})*)(\.\d{1,2})?$/)
                ])
              );
              if (obj.subCoverSumInsured > 0) {
                this.extraCoverDetailForm.patchValue({
                  [obj.subCoverCode]: this.decimalFmt.transform(obj.subCoverSumInsured)
                });
              }
            } else {
              if (!this.extraCoverDetailForm.contains(obj.subCoverCode) && obj.subCoverSumInsured > 0) {
                this.extraCoverDetailForm.addControl(obj.subCoverCode, new FormControl(this.decimalFmt.transform(obj.subCoverSumInsured)));
                this.extraCoverDetailForm.get(obj.subCoverCode)?.disable();
              }
            }

          }
        });
      });
    }
  }

  setExtraCoverageFormForDisabledInput() {

    this.extraCoverList?.forEach((obj, idx) => {
      if (!this.extraCoverDetailForm.contains(obj.subCoverCode)) {
        obj.mtExtCovDtoList?.forEach((subItem, subIdx) => {
          if (subItem.type === 'INPUT' && subItem.disable && obj.subCoverSumInsured > 0) {
            this.extraCoverDetailForm.addControl(obj.subCoverCode, new FormControl(this.decimalFmt.transform(obj.subCoverSumInsured)));
            this.extraCoverDetailForm.get(obj.subCoverCode)?.disable();
          }
        });
      }
    });
  }

  openPopupComp(popup_type: any) {
    this.componentDialogRef = this.dialogService.open(ExtraCoveragePopupEndtComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      width: "800px",
      maxWidth: "800px",
      data: {
        popup_type: popup_type,
        selectedExtraCoverList: this.allSelectedWithRahmahExtraCoverList,
        originalExtraCoverList: this.subCovList,
        packageCode: this.subCovPackageList?.packageCode,
        disabledPreviousExtraCoverList: this.disabledPreviousExtraCoverList,
        cngeRiskDrvrDtoList: this.cngeRiskDrvrDtoForPopupList
      },
    });

    this.componentDialogRef.afterClosed().subscribe((result) => {
      console.log('result is : ' + result)
      if (result) {
        result.selection.forEach(objDialog => {

          let thailandOrKalimantanNewSelect = this.extraCoverList.find(obj1 => (obj1.subCoverCode === '101' || obj1.subCoverCode === '102'|| obj1.subCoverCode === '101(a)'));
          //49536 : removed thailandOrKalimantanPreviousSelect 
          if (this.extraCoverList?.length > 0 && (thailandOrKalimantanNewSelect || (objDialog.subCoverCode === '101' || objDialog.subCoverCode === '102'|| objDialog.subCoverCode === '101(a)'))) {
            if (!this.showThailandTripPopup) {
              this.showThailandTripPopup = true;
              this.warningPopup2("warningPopupTwo", "Not allowed to add more than 1 extra coverages if Thailand/Kalimantan has been selected.");
            }
            return;
          } 

          const newObj = { ...objDialog, selected: true };
          this.extraCoverList.push(newObj);
          this.extraCoverList.forEach(element => {
            this.selection.select(element)
          });
          this.updateSelectedAndAllListToOPUS = this.updateSelectedAndAllListToOPUS.map((obj) => {
            if (objDialog.subCoverCode === obj.subCoverCode) {
              return { ...obj, selected: !obj.selected };
            }
            return obj;
          });
        });

        this.showThailandTripPopup = false;
        this.privateHireCar();
        this.allSelectedWithRahmahExtraCoverList = this.rahmahExtraCoverList.concat(this.topExtraCoverList.concat(this.extraCoverList));
        this.extraCoverDetailForm.controls['extraCoverPackage'].setValue(this.allSelectedWithRahmahExtraCoverList);  //to save quotation
        this.calculatePremium();
      }
    });
  }

  emitData(item: boolean, code: any, location: any) {

    let hasSelectedThailandOrKalimantan = this.extraCoverList.find(obj => (obj.subCoverCode === '101' || obj.subCoverCode === '102'|| obj.subCoverCode === '101(a)'));
    let selectedToUncheck = this.extraCoverList.find(obj => obj.subCoverCode === code);
    if (hasSelectedThailandOrKalimantan || (code === '101' || code === '102' || code === '101(a)')) {
      if (this.extraCoverList?.length > 0 && !selectedToUncheck) {
        this.warningPopup("warningPopupTwo", "Not allowed to add more than 1 extra coverages if Thailand/Kalimantan has been selected.");
        return;
      }
    }

    if ((this.subCovPackageList?.packageCode === 'JPPP_0100' || this.subCovPackageList?.packageCode === 'JPPP_0200') && this.subCovPackageList?.selected) {
      let perils = this.disabledPreviousExtraCoverList.find(obj => (obj.subCoverCode === 'A221' || obj.subCoverCode === '57'));
      if (perils && perils.subCoverCode !== code &&  (code === 'A221' || code === '57')) {
          this.warningPopup("warningPopupTwo", "Please select 'Inclusion of Special Perils' or 'Limited Special Perils Cover' to continue.");
          return;
      }
    }

    if (this.extraCoverDetailForm.contains(code)) {
      this.extraCoverDetailForm.removeControl(code);
    }

    if (code === '112') {
      if (this.extraCoverDetailForm.contains(code + this.amountPerDayFormName)) {
        this.extraCoverDetailForm.removeControl(code + this.amountPerDayFormName);
      }

      if (this.extraCoverDetailForm.contains(code + this.noOfDayFormName)) {
        this.extraCoverDetailForm.removeControl(code + this.noOfDayFormName);
      }
    }

    if (code === 'A207') {
      if (this.extraCoverDetailForm.contains("CHECKBOX_P2P")) {
        this.extraCoverDetailForm.removeControl("CHECKBOX_P2P");
      }
    }

    if (location === 'defaultedCR14Value') {
      this.subCovPackageList = {
        ...this.subCovPackageList,
        selected: item
      };
    }

    if (location === 'topHeader') {
      this.subCovPackageList = {
        ...this.subCovPackageList,
        selected: !this.subCovPackageList.selected
      };
      this.isWaiver = false;
      this.isAllDriver = false;
    }

    if (location === 'defaultedExtraCover') {
      this.defaultedExtraCoverList.forEach((obj, index) => {
        if (code == obj.subCoverCode) {
          this.defaultedExtraCoverList.splice(index, 1);
          const newObj = { ...obj, selected: true };
          this.extraCoverList.push(newObj);
          this.extraCoverList.sort((a, b) => {
            if (a.top !== b.top) {
              return a.top ? -1 : 1;  // 'true' (top) comes first
            }
            return a.sequenceNumber - b.sequenceNumber;
          });
        }
      });
      this.setExtraCoverageFormForDisabledInput();

      this.updateSelectedAndAllListToOPUS = this.updateSelectedAndAllListToOPUS.map((obj) => {
        if (code === obj.subCoverCode) {
          return { ...obj, selected: !obj.selected };
        }
        return obj;
      });
    } else {
      this.extraCoverList.forEach((obj, index) => {
        if (code == obj.subCoverCode) {
          this.extraCoverList.splice(index, 1);
          if (obj.top == true) {
            const newObj = { ...obj, selected: false };
            this.defaultedExtraCoverList.push(newObj);
            // Ascending order defaultedExtraCoverList
            this.defaultedExtraCoverList.sort((a, b) => {
              return a.sequenceNumber - b.sequenceNumber;
            });

            this.extraCoverList.sort((a, b) => {
              if (a.top !== b.top) {
                return a.top ? -1 : 1;  // 'true' (top) comes first
              }
              return a.sequenceNumber - b.sequenceNumber;
            });
          }
        }
      });

      this.updateSelectedAndAllListToOPUS = this.updateSelectedAndAllListToOPUS.map((obj) => {
        if (code === obj.subCoverCode) {
          if (!obj.selected == false) {
            return { ...obj, selected: !obj.selected, subCoverPrem: 0, mtExtCovDtoList: null };

          } else {
            return { ...obj, selected: !obj.selected };
          }
        }
        return obj;
      });
    }
    //this.privateHireCar();
    this.allSelectedWithRahmahExtraCoverList = this.rahmahExtraCoverList.concat(this.topExtraCoverList.concat(this.extraCoverList));
    this.extraCoverDetailForm.controls['extraCoverPackage'].setValue(this.allSelectedWithRahmahExtraCoverList);  //to save quotation
    this.calculatePremium();
    console.log("this.extraCoverList" + this.extraCoverList);
    console.log("this.topExtraCoverList" + this.topExtraCoverList);
  }

  emitReinstateData(item: any, code: any) {

    const previousSubCover =  this.endtHtgePol.riskList?.[0]?.coverList?.[0]?.subCoverList?.filter(o1 => o1.subCoverCode === code);

    this.extraCoverList = this.extraCoverList.map((obj) => {
      if (code === obj.subCoverCode) {
        return {
          ...obj,
          reinstateInd: item.checked,
          //selected: item.checked,
          subCoverSumInsured: previousSubCover?.[0]?.subCoverSumInsured.toString(),
          claimInd: item.checked,
          actionCode: item.checked ? "A" : "U"
        };
      }
      return obj;
    });


    this.updateSelectedAndAllListToOPUS = this.updateSelectedAndAllListToOPUS.map((obj) => {
      if (code === obj.subCoverCode) {
        return {
          ...obj,
          reinstateInd: item.checked,
          //selected: item.checked,
          subCoverSumInsured: previousSubCover?.[0]?.subCoverSumInsured.toString(),
          claimInd: item.checked,
          actionCode: item.checked ? "A" : "U"
        };
      }
      return obj;
    }); 

    //this.privateHireCar();
    this.allSelectedWithRahmahExtraCoverList = this.rahmahExtraCoverList.concat(this.topExtraCoverList.concat(this.extraCoverList));
    this.extraCoverDetailForm.controls['extraCoverPackage'].setValue(this.allSelectedWithRahmahExtraCoverList);  //to save quotation
    this.calculatePremium();
    console.log("this.extraCoverList" + this.extraCoverList);
    console.log("this.topExtraCoverList" + this.topExtraCoverList);
  }

  privateHireCar() {
    this.checkPrivateHireCar = this.extraCoverList.find(top => top.subCoverCode === 'A202');
    if (this.checkPrivateHireCar) {
      this.privateHireCarIsSelected = true;
    } else {
      this.privateHireCarIsSelected = false;
    }
  }

  thailandTripExtraCoverage() {
    this.checkThailandTrip = this.extraCoverList.find(top => top.subCoverCode === '101'|| top.subCoverCode === '101(a)');
    let thailandPreviousSelect = this.disabledPreviousExtraCoverList?.find(obj1 => (obj1.subCoverCode === '101'|| obj1.subCoverCode === '101(a)'));

    if (this.checkThailandTrip) {
      if (!this.extraCoverDetailForm.contains('currentThaiStartDate')) {
        this.extraCoverDetailForm.addControl(
          'currentThaiStartDate',
          new FormControl('', [Validators.required, this.validateThaiStartDate])
        );
      }
      if (!this.extraCoverDetailForm.contains('currentThaiEndDate')) {
        this.extraCoverDetailForm.addControl(
          'currentThaiEndDate',
          new FormControl('', [Validators.required, this.validateThaiEndDate])
        );
      }
      this.thailandTripIsSelected = true;

    } else if (thailandPreviousSelect) {
      if(thailandPreviousSelect.effectiveDate && thailandPreviousSelect.expiryDate){
        if (!this.extraCoverDetailForm.contains('currentThaiStartDate')) {
          this.extraCoverDetailForm.addControl(
            'currentThaiStartDate',
            new FormControl({ value: thailandPreviousSelect.effectiveDate, disabled: true })
          );
        }
        if (!this.extraCoverDetailForm.contains('currentThaiEndDate')) {
          this.extraCoverDetailForm.addControl(
            'currentThaiEndDate',
            new FormControl({ value: thailandPreviousSelect.expiryDate, disabled: true })
          );
        }
        this.thailandTripIsSelected = true;
      }
    } else {
      if (this.extraCoverDetailForm.contains('currentThaiStartDate')) {
        this.extraCoverDetailForm.removeControl('currentThaiStartDate');
      }

      if (this.extraCoverDetailForm.contains('currentThaiEndDate')) {
        this.extraCoverDetailForm.removeControl('currentThaiEndDate');
      }
      this.thailandTripIsSelected = false;

      this.store.dispatch(new STORE_THAILAND_DATE(""));
      this.thailandDates = null;
    }

    if (this.thailandDates?.currentThaiStartDate && this.thailandDates?.currentThaiEndDate) {
      this.extraCoverDetailForm.patchValue({
        currentThaiStartDate: this.thailandDates?.currentThaiStartDate,
        currentThaiEndDate: this.thailandDates?.currentThaiEndDate,
      });
    }
  }

  validateThaiStartDate: ValidatorFn = (): ValidationErrors | null => {
    if (this.extraCoverDetailForm.get('currentThaiStartDate')?.value) {
      const startDate = this.extraCoverDetailForm.get('currentThaiStartDate')?.value;
      const endDate = this.extraCoverDetailForm.get('currentThaiEndDate')?.value;

      if (startDate) {
        const currentThaiStartDate = new Date(startDate);
        const currentThaiEndDate = new Date(endDate);

        const endtEffectiveDate = new Date(this.issuanceData?.issuance?.endtEffectiveDate);
        const endtExpiryDate = new Date(this.issuanceData?.issuance?.endtExpiryDate);


        // Check if the start date is greater than today's date
        if ((currentThaiStartDate < endtEffectiveDate) || (currentThaiStartDate > endtExpiryDate)) {
          return { startDateNotFuture: true };
        }

        if (currentThaiStartDate > currentThaiEndDate) {
          return { startDateLessThanExpiryDate: true };
        }
      }
    }

    return null;
  };

  validateThaiEndDate: ValidatorFn = (): ValidationErrors | null => {
    if (this.extraCoverDetailForm.get('currentThaiEndDate')?.value) {
      const startDate = this.extraCoverDetailForm.get('currentThaiStartDate')?.value;
      const endDate = this.extraCoverDetailForm.get('currentThaiEndDate')?.value;

      if (endDate) {
        const currentThaiStartDate = new Date(startDate);
        const currentThaiEndDate = new Date(endDate);
        const endtEffectiveDate = new Date(this.issuanceData?.issuance?.endtEffectiveDate);
        const endtExpiryDate = new Date(this.issuanceData?.issuance?.endtExpiryDate);


        // Check if the start date is greater than today's date
        if ((currentThaiEndDate < endtEffectiveDate) || (currentThaiEndDate > endtExpiryDate)) {
          return { startDateNotFuture: true };
        }

        if (currentThaiStartDate > currentThaiEndDate) {
          return { startDateLessThanExpiryDate: true };
        }
      }
    }

    return null;
  };

  selectExtraCover($event) {
    // if (this.subCovList) {
    this.isAllDriver = $event;
    //  this.calculatePremium();
    // }
  }

  selectWaiver($event: boolean) {
    this.isWaiver = $event;
    this.calculatePremium();
  }

  selectAllDriver($event: boolean) {
    this.isAllDriver = $event;
    this.calculatePremium();
  }

  removeExtraCover($event) {
    let obj = this.subCovList.find(item => item.subCoverCode === $event);
    this.extraCoverList = this.extraCoverList.filter(item => item.subCoverCode !== $event);

    this.extraCoverList.forEach(element => {
      this.selection.deselect(element)
    });
    this.allSelectedWithRahmahExtraCoverList = this.topExtraCoverList.concat(this.extraCoverList);
  }

  checkedAllChange() {
    if (this.extraCoverDetailForm.controls['checkedAll'].value) {

      this.defaultedExtraCoverList.forEach((obj) => {
        if (obj.enabled) {
          const matchMRW = this.extraCoverList.find(objMRW => objMRW.subCoverCode === 'PAB-RW');
          const matchMERW = this.extraCoverList.find(objERW => objERW.subCoverCode === 'PAB-ERW');
          if (matchMRW?.enabled == true && obj.subCoverCode === 'PAB-ERW') {
            return;
          }

          if (matchMERW?.enabled == true && obj.subCoverCode === 'PAB-RW') {
            return;
          }

          if ((this.subCovPackageList?.packageCode === 'JPPP_0100' || this.subCovPackageList?.packageCode === 'JPPP_0200') && this.subCovPackageList?.selected) {
            const perils = this.disabledPreviousExtraCoverList.find(item => ((item.subCoverCode === 'A221' && item.selected) || (item.subCoverCode === '57' && item.selected)))
            if (perils && perils.subCoverCode !== obj.subCoverCode && (obj.subCoverCode === 'A221' || obj.subCoverCode === '57')) {
              if(!this.perilWarningPopup){
                this.warningPopup2("warningPopupTwo", "Please select 'Inclusion of Special Perils' or 'Limited Special Perils Cover' to continue.");
                this.perilWarningPopup = true;
              }
              return;
            }
          }

          const newObj = { ...obj, selected: true };


          let thailandOrKalimantan = this.extraCoverList.find(obj1 => (obj1.subCoverCode === '101' || obj1.subCoverCode === '102'|| obj1.subCoverCode === '101(a)'));
          //49536 : removed thailandOrKalimantanPreviousSelect 
          //let thailandOrKalimantanPreviousSelect = this.disabledPreviousExtraCoverList.find(obj1 => (obj1.subCoverCode === '101' || obj1.subCoverCode === '102'));

          if (this.extraCoverList?.length > 0 && (thailandOrKalimantan || (obj.subCoverCode === '101' || obj.subCoverCode === '102' || obj.subCoverCode === '101(a)'))) {
            if (!this.showThailandTripPopup) {
              this.showThailandTripPopup = true;
              this.warningPopup2("warningPopupTwo", "Not allowed to add more than 1 extra coverages if Thailand/Kalimantan has been selected.");
            }
            this.extraCoverDetailForm.controls['checkedAll'].setValue(false);
            return;
          }

          // if (thailandOrKalimantanPreviousSelect) {
          //   if (!this.showThailandTripPopup) {
          //     this.showThailandTripPopup = true;
          //     this.warningPopup2("warningPopupTwo", "Not allowed to add more than 1 extra coverages if Thailand/Kalimantan has been selected.");
          //   }
          //   this.extraCoverDetailForm.controls['checkedAll'].setValue(false);
          //   return;
          // }

          this.extraCoverList.push(newObj);
        }
      });
      this.perilWarningPopup = false;
      this.showThailandTripPopup = false;
      this.defaultedExtraCoverList = [];

      this.extraCoverList.sort((a, b) => {
        if (a.top !== b.top) {
          return a.top ? -1 : 1;
        }
        return a.sequenceNumber - b.sequenceNumber;
      });

      this.updateSelectedAndAllListToOPUS = this.updateSelectedAndAllListToOPUS.map((obj2) => {
        const matchingObj = this.extraCoverList.find(obj1 => obj1.subCoverCode === obj2.subCoverCode);
        if (matchingObj) {
          return { ...obj2, selected: true };
        }
        return obj2;
      });

      this.setExtraCoverageForm();
    } else {
      this.extraCoverList.forEach(obj => {
        if (this.extraCoverDetailForm.contains(obj.subCoverCode)) {
          this.extraCoverDetailForm.removeControl(obj.subCoverCode);
        }
      })

      this.extraCoverList = [];
      this.updateSelectedAndAllListToOPUS =  this.oriPreviousExtraCoverList || [];
    }



    this.privateHireCar();
    this.allSelectedWithRahmahExtraCoverList = this.rahmahExtraCoverList.concat(this.topExtraCoverList.concat(this.extraCoverList.concat(this.disabledPreviousExtraCoverList)));
    this.extraCoverDetailForm.controls['extraCoverPackage'].setValue(this.allSelectedWithRahmahExtraCoverList); //to save quotation

    this.calculatePremium();


  }

  calculatePremium() {

    if (this.updateSelectedAndAllListToOPUS && this.updateSelectedAndAllListToOPUS.length > 0) {
      this.updateSelectedAndAllListToOPUS = this.updateSelectedAndAllListToOPUS.map(subCover => {
        const subCoverClone = { ...subCover }; // Clone the object
        if (subCoverClone.hasOwnProperty('elementEndorsementPOIList')) {
          subCoverClone.elementEndorsementPOIList = []; // Modify the clone
        }
        return subCoverClone;
      });
    }
    

    let endtUpdatedData = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step2?.endtUpdatedData);
    endtUpdatedData = {
      ...endtUpdatedData,
      riskList: [{
        ...endtUpdatedData.riskList[0],
        coverList: [{
          ...endtUpdatedData.riskList[0].coverList[0],
          mtRoadPlacementTblInd: this.mtRoadPlacementTblInd,
          mtRoadEligibleInd: this.mtRoadEligibleInd,
          extracover: this.allSelectedWithRahmahExtraCoverList,
          coverDto: {
            ...this.coverDto,
            subCovList: [
              ...this.updateSelectedAndAllListToOPUS
            ],
            subCovPackageList: this.subCovPackageList? [this.subCovPackageList] : []
          },
          subCoverList: this.allSelectedWithRahmahExtraCoverList
        }]
      }]
    };
    this.store.dispatch(new UPDATE_ENDORSEMENT_STEP2({
      isReset: false,
      cngeNote: endtUpdatedData
    }));
    this.endtCalculatePremium.emit();
  }

  populateDriverNameData() {
    let driverNameForm = this.coverageFmGroup.controls["driverNameForm"].getRawValue();
    const namedDriverList = driverNameForm.rows
    let cngeRiskDrvrDtoList = namedDriverList.map((driver) => {
      let driverName;
      if (driver.driverName) {
        driverName = driver.driverName;
      } else if (driver?.cngeRiskDrvrPkDto?.driverName) {
        driverName = driver.cngeRiskDrvrPkDto.driverName;
      }

      let cngeRiskDrvrPkDto = {
        cngeRiskDrvrPkDto: {
          driverName: driverName ? driverName : "",
          driverType: "NORM",
        },
        driverId: driver.driverId,
        driverAge: driver.driverAge,
        driverSeq: driver.driverSeq,
      };

      return cngeRiskDrvrPkDto;
    });
    return cngeRiskDrvrDtoList;
  }



  populateVehicleDetailsData(data) {
    let selectedMakeModel = this.store.selectSnapshot<any>((state) => state.SatMotorState.data.step3?.coverage?.selectedMakeModel);
    let makeModelPrintInd = data.makeModelPrintInd ? "Y" : "N";
    return {
      ...data, ...selectedMakeModel,
      makeModelPrintInd: makeModelPrintInd,
      importStatus: selectedMakeModel.importStatus,
      vehModelNvic: selectedMakeModel.vehModelCodeNvic,
      vehicleModel: selectedMakeModel.vehModelCodeNvic,
      nvicNo: selectedMakeModel.nvicCode,
      vehicleCapacity: this.numberFmt.transform(data.vehicleCapacity)
    };
  }

  onChangeSubCoverSumInsured(subCoverCodeValue: any, subCoverSumInsuredValue: any, subItemType: any) {
    let formatSubCoverSumInsuredValue = subCoverSumInsuredValue.value ? subCoverSumInsuredValue.value : 0.00;

    if (subItemType === 'INPUT') {
      let formattedValue = parseFloat(formatSubCoverSumInsuredValue).toFixed(2);
      if (!(/^(?!0(?:\.0{1,2})?$)(\d{1,8}(,\d{3})*)(\.\d{1,2})?$/.test(formattedValue))) {
        this.extraCoverDetailForm.controls[subCoverCodeValue].markAsTouched();
        return;
      }
    }

    if (formatSubCoverSumInsuredValue) {
      formatSubCoverSumInsuredValue = formatSubCoverSumInsuredValue.toString().replace(/,/g, "");


      this.extraCoverList = this.extraCoverList.map((obj) => {
        if (subCoverCodeValue === obj.subCoverCode) {
          return { ...obj, subCoverSumInsured: formatSubCoverSumInsuredValue };
        }
        return obj;
      });

      this.extraCoverList.sort((a, b) => {
        if (a.top !== b.top) {
          return a.top ? -1 : 1;
        }
        return a.sequenceNumber - b.sequenceNumber;
      });


      this.updateSelectedAndAllListToOPUS = this.updateSelectedAndAllListToOPUS.map((obj) => {
        if (subCoverCodeValue === obj.subCoverCode) {
          return { ...obj, subCoverSumInsured: formatSubCoverSumInsuredValue };
        }
        return obj;
      });
      this.allSelectedWithRahmahExtraCoverList = this.rahmahExtraCoverList.concat(this.topExtraCoverList.concat(this.extraCoverList));
      this.extraCoverDetailForm.controls['extraCoverPackage'].setValue(this.allSelectedWithRahmahExtraCoverList);  //to save quotation
      this.calculatePremium();

    }
  }

  populateTypeOfCoverageData(data) {
    return {
      ...data, sumInsured: this.numberFmt.transform(data.sumInsured), excessAmount: this.numberFmt.transform(data.excessAmount),
      basicPremium: this.numberFmt.transform(data.basicPremium), annualPremium: this.numberFmt.transform(data.annualPremium),
      grossPremium: this.numberFmt.transform(data.grossPremium), ncdAmount: this.numberFmt.transform(data.ncdAmount),
      ncdPercentage: this.numberFmt.transform(data.ncdPercentage)
    };
  }

  onChangeProduct(subCoverCodeValue: any, dropdownCode: any, dropdownDesc: any) {
    // Helper function to update and sort lists
    const updateAndSortLists = (property: string, value: any) => {
      this.extraCoverList = this.extraCoverList.map((obj) => {
        if (subCoverCodeValue === obj.subCoverCode) {
          return { ...obj, [property]: value };
        }
        return obj;
      });

      //update to OPUS list
      this.updateSelectedAndAllListToOPUS = this.updateSelectedAndAllListToOPUS.map((obj) => {
        if (subCoverCodeValue === obj.subCoverCode) {
          return { ...obj, [property]: value };
        }
        return obj;
      });

      // Sorting logic
      this.extraCoverList.sort((a, b) => {
        if (a.top !== b.top) {
          return a.top ? -1 : 1;
        }
        return a.sequenceNumber - b.sequenceNumber;
      });

      // Combining lists
      this.allSelectedWithRahmahExtraCoverList = this.rahmahExtraCoverList.concat(this.topExtraCoverList.concat(this.extraCoverList));
      this.extraCoverDetailForm.controls['extraCoverPackage'].setValue(this.allSelectedWithRahmahExtraCoverList);  //to save quotation
    };

    if (dropdownDesc === this.planUnitLabel) {
      updateAndSortLists('planCode', dropdownCode);
    } else if (dropdownDesc === this.noOfDayLabel) {
      updateAndSortLists('subCoverNumberOfDays', dropdownCode);
      updateAndSortLists('subCoverDays', dropdownCode);
    } else if (dropdownDesc === this.amountPerDayLabel) {
      updateAndSortLists('subCoverAmtPerDay', dropdownCode);
      updateAndSortLists('subCoverAmtday', dropdownCode);
    } else if (dropdownDesc === 'CHECKBOX_P2P') { //might change
      updateAndSortLists('vendorList', dropdownCode);
    }

    this.calculatePremium();
  }


  getSubCoverNumberOfDaysAsString(code: string) {
    return code.toString();
  }

  validateChangedFields() {
    const subCovlistString = JSON.stringify(this.subCovList);
    let originalSelectedExtraCoverageList = this.store.selectSnapshot<any>((state) => state.SatMotorState.data?.step3?.coverage?.selectedSubCovList) || [];

    if (this.cnoteType === 'ENDT29' && originalSelectedExtraCoverageList && originalSelectedExtraCoverageList.length > 0) {
      let getClaimIndList = originalSelectedExtraCoverageList.some(o1 => o1.claimInd);
      if(getClaimIndList){
        let hasChanged = this.subCovList.some(o1 => o1.claimInd && o1.subCoverPrem > 0);
        if (hasChanged) {
          return true
        }
      }
      return false;
    }

    const initExtraCoverageListString = JSON.stringify(originalSelectedExtraCoverageList);

    if (subCovlistString === initExtraCoverageListString) {
      return false;
    }

    return true;
  }

  validateExtraCoverDetails() {
    if (!this.extraCoverDetailForm.valid) {
      this.extraCoverDetailForm.markAllAsTouched();
      ScrollToError.scrollToError('.ng-invalid[formControlName]');
      return false;
    }

    return true;
  }

  storeThailandTripDates() {
    if (this.checkThailandTrip) {
      let payload = {
        currentThaiStartDate: this.extraCoverDetailForm.get('currentThaiStartDate').value,
        currentThaiEndDate: this.extraCoverDetailForm.get('currentThaiEndDate').value
      }
      this.store.dispatch(new STORE_THAILAND_DATE(payload));
    }
  }

  validateEhailingDriver() {
    let endtUpdatedData = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step2?.endtUpdatedData);

    if (this.subCovList && this.subCovList.length > 0) {
      let privateHireCar = this.subCovList.find(ex => ex.subCoverCode === 'A202' && ex.selected == true)
      if (privateHireCar) {
        const ehailingDriverDetails = this.extraCoverDetailForm.controls["ehailingDriverDetails"].getRawValue()?.rows;
        if (ehailingDriverDetails) {
          let driver = ehailingDriverDetails.map((d) => { return d.driverId + d.driverName; });
          if (!driver.filter(Boolean).length) {
            this.dialogService.open(SimpleModalComponent, {
              showCloseIcon: false, width: "400px", maxWidth: "400px",
              disableClose: true,
              data: { type: 'WARNING', message: "Minimum 1 e-Hailing driver is required." },
            });
            return false;
          } else {
            let filteredDrivrList = [];
            if (ehailingDriverDetails && ehailingDriverDetails.length > 0) {
              filteredDrivrList = ehailingDriverDetails.filter(driver => driver.driverName && driver.driverId);
            }
            this.store.dispatch(new STORE_EHAILING_DETAILS(endtUpdatedData.cnoteType, filteredDrivrList));
          }
        }
      }
    }

    return true;
  }

  disableInitExtraCoverage() {
    if (this.countInitSelectedExtraCoverageList == 0) {
      this.countInitSelectedExtraCoverageList++
      this.initSelectedExtraCoverageList = this.extraCoverList;
    }

    const selectedExtraCoverageList = this.initSelectedExtraCoverageList.filter(obj => obj.selected === true);

    this.extraCoverList = this.extraCoverList.map(obj => {
      const isSelected = selectedExtraCoverageList.find(selectedObj => selectedObj.selected === obj.selected && selectedObj.subCoverCode === obj.subCoverCode);

      if (isSelected) {
        return { ...obj, enabled: false };
      }

      return obj;
    });
  }

  selectionChange(event: any): void {
    this.selectedCheckboxP2p = event;
    this.vendorCodeList = []

    if (!Array.isArray(this.selectedCheckboxP2p)) {
      this.selectedCheckboxP2p = [];
    }

    //for coverDto save to db
    this.vendorCodeList = event.map(code => ({
      description: code
    }));

    const selectedCodesString = this.selectedCheckboxP2p.join(",");

    this.onChangeProduct("A207", selectedCodesString, "CHECKBOX_P2P");
  }

  removeNewLinesFromOpus(value: any, item: any, location: any) {
    if (value && value.includes("$NEWLINES")) {
      if (location === 'middle' && (item.subCoverCode === 'PAB-RW' || item.subCoverCode === 'PAB-ERW' || item.subCoverCode === 'PAB3')) {
        return value.replace(/.*\$NEWLINES/, '');
      }
      return value.replace("$NEWLINES", "<br>");
    }
    return value;
  }

  get extraCoverPackage() {
    return this.extraCoverDetailForm.controls["extraCoverPackage"];
  }

  checkIsDisabledCheckbox(item: any): boolean {
    if (this.cnoteType === 'ENDT29') {
      this.disableAddMore = true;
      this.disableTopCheckbox = true;
      return true;
    } else if (item.enabled) {
      return false;
    }

    return true;
  } 

  reinstateTickCheckbox(item: any): boolean {
    const isReinstateSubCoverCode = ['89', '97', '97A'].includes(item.subCoverCode);
    const previousSubCover =  this.endtHtgePol.riskList?.[0]?.coverList?.[0]?.subCoverList?.filter(o1 => o1.subCoverCode === item.subCoverCode);
  
    if (!isReinstateSubCoverCode) {
      return item.selected;
    }
  
    if (item.selected) {
      if (!previousSubCover?.[0]?.claimInd) {
        return true;
      }
      return item.reinstateInd;
    }

    if (!item.selected && previousSubCover?.[0]?.claimInd) {
      return item.reinstateInd;
    }

    return false;
  }

  reinstateEnableCheckbox(item: any): boolean {
    const previousSubCover =  this.endtHtgePol.riskList?.[0]?.coverList?.[0]?.subCoverList?.filter(o1 => o1.subCoverCode === item.subCoverCode);
  
    if (previousSubCover?.[0]?.claimInd) {
      return true;
    }

    return false;
  }

  checkDisableInput(item: any): boolean {
    if (item.mtExtCovDtoList[0].type === 'INPUT' || item.mtExtCovDtoList[0].type === 'DROPDOWN') {

      if (this.cnoteType === 'ENDT29') {
        if (item.reinstateInd && (item.subCoverCode === '89' || item.subCoverCode === '97' || item.subCoverCode === '97A')) {
          this.extraCoverDetailForm.get(item.subCoverCode)?.enable();
          return true;
        } else {
          return false;
        }
      } else {
        if (item.enabled && !item.mtExtCovDtoList?.[0].disable) {
          this.extraCoverDetailForm.get(item.subCoverCode)?.enable();
          return true
        } else {
          this.extraCoverDetailForm.get(item.subCoverCode)?.disable();
          return false
        }
      }
    }
    return true;
  }

  showDisplayInput(item: any): boolean {

    if (item.mtExtCovDtoList[0].type === 'INPUT' || item.mtExtCovDtoList[0].type === 'DROPDOWN') {
      if (this.cnoteType === 'ENDT29') {
        if (item.enabledForEndt && (item.subCoverCode === '89' || item.subCoverCode === '97' || item.subCoverCode === '97A')) {
          return true;
        } else {
          return false;
        }
      } else {
        if (item.enabled && !item.mtExtCovDtoList?.[0].disable) {
          return true
        } else {
          return false
        }
      }
    }
    return true;
  }

  warningPopup(popup_type: any, error: any) {
    this.warningPopupModal = this.dialogService.open(WarningPopupComponent, {
      ariaLabel: "A simple dialog",
      width: '400px',
      showCloseIcon: false,
      disableClose: true,
      data: {
        popup_type: popup_type,
        popup_error: error
      },
    });
    this.warningPopupModal.afterClosed().subscribe((result) => {
      this.calculatePremium();
    });
  }

  warningPopup2(popup_type: any, error: any) {
    this.warningPopupModal = this.dialogService.open(WarningPopupComponent, {
      ariaLabel: "A simple dialog",
      width: '400px',
      showCloseIcon: false,
      disableClose: true,
      data: {
        popup_type: popup_type,
        popup_error: error
      },
    });
  }

  disablePreviousExtraCoverPackageCheckbox(): boolean {
    if (this.cnoteType === 'ENDT29') {
      return true;
    }

    if (this.cnoteType === 'ENDT17' && this.subCovPackageList.selected) {
      return true;
    } else {
      return false;
    }

  }

  onChangeThailandDate(name: any, event: any) {
    if (this.extraCoverDetailForm.get('currentThaiStartDate')?.valid && this.extraCoverDetailForm.get('currentThaiEndDate')?.valid) {

      this.updateSelectedAndAllListToOPUS = this.updateSelectedAndAllListToOPUS.map(obj => {
        if (obj.subCoverCode === '101') {
          return {
            ...obj,
            effectiveDate: this.extraCoverDetailForm.get('currentThaiStartDate')?.value,
            expiryDate: this.extraCoverDetailForm.get('currentThaiEndDate')?.value
          }
        }

        return obj;
      })

      this.extraCoverList = this.extraCoverList.map(obj => {
        if (obj.subCoverCode === '101') {
          return {
            ...obj,
            effectiveDate: this.extraCoverDetailForm.get('currentThaiStartDate')?.value,
            expiryDate: this.extraCoverDetailForm.get('currentThaiEndDate')?.value
          }
        }

        return obj;
      })

      this.allSelectedWithRahmahExtraCoverList = this.rahmahExtraCoverList.concat(this.topExtraCoverList.concat(this.extraCoverList));
      this.extraCoverDetailForm.controls['extraCoverPackage'].setValue(this.allSelectedWithRahmahExtraCoverList);
      this.calculatePremium();
    }
  }
}
